import { render, staticRenderFns } from "./myoverlay.vue?vue&type=template&id=5f26b860&scoped=true"
import script from "./myoverlay.vue?vue&type=script&lang=js"
export * from "./myoverlay.vue?vue&type=script&lang=js"
import style0 from "./myoverlay.vue?vue&type=style&index=0&id=5f26b860&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f26b860",
  null
  
)

export default component.exports